import { Row, Skeleton } from '@components'
import Column from '@components/column'
import {
  BookEntry,
  BookInfo,
  BookInformation,
  BookWrapper,
  DriverWrapper,
  HistoryLendHeader,
  HistoryLendToContainer,
  LendDateDetails,
} from '../style'
const HistoryLoading = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <BookEntry key={index}>
          <BookInformation>
            <BookWrapper>
              <Skeleton width="100%" height={80} radius={8} />
            </BookWrapper>
            <BookInfo>
              <Column rowGap={6}>
                <Skeleton width={100} height={10} radius={8} />
                <Skeleton width={80} height={10} radius={8} />
                <Skeleton width={50} height={10} radius={8} />
              </Column>
              <Skeleton width={60} height={25} radius={4} />
            </BookInfo>
          </BookInformation>
          <HistoryLendToContainer>
            <HistoryLendHeader>
              <Skeleton width={80} height={10} radius={8} />
              <Skeleton width={60} height={25} radius={4} />
            </HistoryLendHeader>
            <LendDateDetails>
              {[...Array(3)].map((_, i) => (
                <Column key={i} rowGap={6}>
                  <Skeleton width={60} height={10} radius={4} />
                  <Skeleton width={60} height={25} radius={4} />
                </Column>
              ))}
            </LendDateDetails>
          </HistoryLendToContainer>
          <DriverWrapper>
            <Column rowGap={6}>
              <Skeleton width={50} height={10} radius={8} />
              <Row colGap={12}>
                <Skeleton width={48} height={48} radius={4} />
                <Column rowGap={6}>
                  <Skeleton width={150} height={10} radius={8} />
                  <Skeleton width={120} height={10} radius={8} />
                  <Skeleton width={100} height={10} radius={8} />
                </Column>
              </Row>
            </Column>
          </DriverWrapper>
        </BookEntry>
      ))}
    </>
  )
}

export default HistoryLoading
